<template>
  <div class="components-upload" :style="{ height: height / fontSize + 'rem' }">
    <div class="container">
      <div class="upload-btn">
        <span class="sel-btn">添加附件</span>
        <span class="not-sel">未选择文件</span>
        <input
          class="btn-input"
          type="file"
          @change="uploadFile1"
          ref="uploadFile"
        />
      </div>
      <div class="text" v-if="fileNameArr.length > 0 && changed">
        <ul class="file-list">
          <li v-for="(item, index) in fileNameArr" :key="index">
            {{ item.name }}
            <span class="remove" @click="remove(index)">X</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { upload } from "../../../api/audit";

export default {
  name: "HyUploadMultiple",
  data() {
    return {
      fileNameArr: [],
      height: 0,
      fontSize: 0,
      changed: true
    };
  },
  props: {
    reset: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reset(newVal) {
      if (newVal) {
        this.fileName = "";
        this.fileNameArr = [];
        this.height = 0;
      }
    }
  },
  mounted() {
    const doc = document.documentElement;
    const fontSize = Number(doc.style.fontSize.replace("px", ""));
    this.fontSize = fontSize;
  },
  methods: {
    /**
     * 上传文件
     */
    uploadFile1() {
      const uploadFile = this.$refs.uploadFile;
      const file = uploadFile.files[0];
      if (this.fileNameArr.length > 9) {
        this.$toast("附件最多上传10个");
        return false;
      }
      if (file) {
        const fileSize = file.size;
        const FILE_MAX_SIZE = 5 * 1024 * 1024;
        if (fileSize === 0) {
          this.$toast("当前图片大小为0，请重新选择");
          return false;
        }
        if (fileSize > FILE_MAX_SIZE) {
          this.$toast(`图片大小不应超过${FILE_MAX_SIZE / 1024 / 1024}M`);
          return false;
        }

        this.changed = true;
        if (file.size === 0) {
          this.$toast("当前图片大小为0，请重新选择");
          return false;
        }
        this.uploadFile(file);
      }
    },
    remove(index) {
      this.fileNameArr.splice(index, 1);
      this.height -= 28;
      this.$emit("remove", this.fileNameArr);
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append("file", file);
      upload(formData)
        .then(res => {
          if (res.status === 100000) {
            const data = res.data;
            this.height += 28;
            this.fileNameArr.push({
              csObjectId: data.objectId,
              name: data.originalName,
              type: 3
            });
            this.$refs.uploadFile.value = null;
            this.$emit("uploadChange", this.fileNameArr);
          } else {
            this.$toast(res.desc || "提交失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast(err || "请求失败");
          return false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.components-upload {
  display: flex;
  .container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    .upload-btn {
      position: relative;
      display: flex;
      align-items: center;
      .sel-btn {
        display: inline-block;
        width: 93px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 1);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        cursor: pointer;
        text-align: center;
        line-height: 28px;
        margin-right: 17px;
      }
      .not-sel {
        font-size: 16px;
      }
    }
    input {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 11;
      font-size: 0;
    }
    .img-box {
      width: 199px;
      height: 114px;
      border-radius: 4px;
      position: relative;

      img {
        margin-top: 16px;
        width: 199px;
        height: 114px;
      }
    }

    .text {
      height: 28px;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      line-height: 28px;
      opacity: 0.8;
    }
    .file-list {
      margin-top: 4px;
      li {
        .remove {
          color: red;
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
